

<div class="tablelist pt-3">

  <div class="row pb-2">
    <div class="col mr-auto">
      <SearchBar
        v-if="searchEnabled"
        ref="searchInput"
        v-model="query"
        :placeholder="searchPlaceHolder"
        @focus="searchbarFocused=true"
        @blur="searchbarFocused=false"
      />
    </div>
    <div v-if="actionButton" class="col-auto">
      <button
        type="button"
        class="btn btn-success"
        tabindex="-1"
        @click.prevent="actionButton.action"
      >
        <i v-if="actionButton.icon" :class="actionButton.icon"></i>
        <span class="d-none d-xl-inline"> {{actionButton.label}} </span>
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <table class="table table-striped table-hover table-bordered">
        <thead>
          <tr>
            <th
              v-for="(column, index) in columns"
              :key="`tablehead-${index}`"
              scope="col"
              :class="{ active: isActiveSortColumn(index) }"
              @click="onTableheadClick(column, index)"
            >
              {{ column.label }}
              <span v-if="column.sort && column.sort.enabled">
                <i v-if="!isActiveSortColumn(index)" class="fas fa-sort"/>
                <i v-if="isActiveSortColumn(index) && sortOptions.order === 'ASC'" class="fas fa-sort-up" />
                <i v-if="isActiveSortColumn(index) && sortOptions.order === 'DESC'" class="fas fa-sort-down" />
              </span>
            </th>

            <th v-if="actions" class="w-1 text-center text-nowrap">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, dataIndex) in filteredData">
            <tr
              :key="`data-${dataIndex}`"
              ref="row"
              :class="{
                focused: focusIndex === dataIndex,
                notclickable: rowsNotClickable
              }"
              tabindex="0"
              @focus="onRowFocus(item.data, dataIndex)"
              @blur="onRowBlur(item.data, dataIndex)"
              @click="onRowClick(item.data, item.meta.index)"
            >
              <td
                v-for="(column, columnIndex) in columns"
                :key="`column-${columnIndex}`"
                class="p-10"
                :title="column.tooltip ? column.tooltip(item.data) : undefined"
              >
                <div
                  v-if="column.badge"
                  :class="[column.badgeClass(getColumnData(item, column))]"
                  class="badge"
                >
                  <i v-if="column.badgeIcon && column.badgeIcon(item.data)" :class="column.badgeIcon(item.data)" />
                  <span> {{getColumnData(item, column)}} </span>
                </div>
                <i
                  v-else-if="column.icon"
                  :class="[column.iconClass(getColumnData(item, column))]"
                />
                <input v-else-if="column.editable"
                   :value="getColumnData(item, column)"
                   @input="event => onDataChanged(item, event.target.value)"/>
                <span v-else > {{getColumnData(item, column)}} </span>
              </td>

              <template v-if="actions">
                <td
                  class="p-10 w-1 text-center text-nowrap"
                >
                  <template v-for="(action, actionIndex) in actions">
                    <button
                      v-if="!action.hidden || !action.hidden(item.data)"
                      :key="`action-${actionIndex}`"
                      :class="[action.buttonClass ? action.buttonClass : 'btn-primary']"
                      type="button"
                      class="btn btn-sm mr-1"
                      tabindex="-1"
                      :title="typeof action.title === 'function' ? action.title(item.data) : action.title"
                      :disabled="action.disabled ? action.disabled(item.data) : false"
                      @click.stop="action.expandToggle ? toggleExpandedRow(dataIndex) : action.action(item.data, item.meta.index)"
                    >
                      <i v-if="action.expandToggle" :class="isRowExpanded(dataIndex) ? action.iconExpanded : action.iconCollapsed" />
                      <i v-else-if="action.iconClass" :class="action.iconClass(item.data)" />
                      <i v-else-if="action.icon" :class="action.icon"></i>
                      <span class="d-none d-xl-inline"> {{action.label}} </span>
                    </button>
                  </template>
                </td>
              </template>
            </tr>
            <tr v-if="isRowExpanded(dataIndex)" :key="`expanded-${dataIndex}`">
              <slot name="expanded-row" :item="item.data" />
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>

</div>

